var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GroupbuyingsList'
      }
    }
  }, [_vm._v("團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "編輯團購" : "我要開團"))])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "編輯團購" : "我要開團") + " ")]), _c('section', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v("Step 1: 請選擇開團群組")]), !_vm.isEdit ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "選擇分店",
      "label-for": "input-1"
    }
  }, [_c('div', [_vm.isFetchFirstLayerBranches ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6",
    attrs: {
      "state": _vm.v$.form.branch_id.$error ? false : null,
      "disabled": _vm.isEdit
    },
    on: {
      "change": _vm.handleFirstBranch
    },
    model: {
      value: _vm.firstBranch,
      callback: function callback($$v) {
        _vm.firstBranch = $$v;
      },
      expression: "firstBranch"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇分店 ")]), _vm._l(_vm.mapFirstLayerBranches, function (branch) {
    return _c('b-form-select-option', {
      key: branch.id,
      attrs: {
        "value": branch
      }
    }, [_vm._v(" " + _vm._s(branch.name) + " ")]);
  })], 2)], 1), _c('div', [_vm.isFetchSecondLayerBranches ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _vm._e(), _vm.mapSecondLayerBranches && _vm.mapSecondLayerBranches.length > 1 ? _c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6 mt-2",
    attrs: {
      "state": _vm.v$.form.branch_id.$error ? false : null,
      "disabled": _vm.isEdit
    },
    on: {
      "change": _vm.handleSecondBranch
    },
    model: {
      value: _vm.secondBranch,
      callback: function callback($$v) {
        _vm.secondBranch = $$v;
      },
      expression: "secondBranch"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇分店 ")]), _vm._l(_vm.mapSecondLayerBranches, function (branch) {
    return _c('b-form-select-option', {
      key: branch.id,
      attrs: {
        "value": branch
      }
    }, [_vm._v(" " + _vm._s(branch.name) + " ")]);
  })], 2) : _vm._e()], 1), _c('div', [_vm.isFetchThirdLayerBranches ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _vm._e(), _vm.mapThirdLayerBranches && _vm.mapThirdLayerBranches.length > 1 ? _c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6 mt-2",
    attrs: {
      "state": _vm.v$.form.branch_id.$error ? false : null,
      "disabled": _vm.isEdit
    },
    on: {
      "change": _vm.handleThirdBranch
    },
    model: {
      value: _vm.thirdBranch,
      callback: function callback($$v) {
        _vm.thirdBranch = $$v;
      },
      expression: "thirdBranch"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇分店 ")]), _vm._l(_vm.mapThirdLayerBranches, function (branch) {
    return _c('b-form-select-option', {
      key: branch.id,
      attrs: {
        "value": branch
      }
    }, [_vm._v(" " + _vm._s(branch.name) + " ")]);
  })], 2) : _vm._e()], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.branch_id.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1) : _vm._e(), _vm.form.branch_id || _vm.isEdit ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開團群組",
      "label-for": "input-1"
    }
  }, [!_vm.isEdit ? [_vm.isFetchGroup ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _vm._e(), _c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-1"
    },
    model: {
      value: _vm.form.group_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "group_ids", $$v);
      },
      expression: "form.group_ids"
    }
  }, _vm._l(_vm.groupOptions, function (group) {
    return _c('b-form-checkbox', {
      key: group.id,
      attrs: {
        "value": group.id
      }
    }, [_vm._v(_vm._s(group.name))]);
  }), 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.group_ids.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])] : [this.selectedGroup ? _c('div', [_vm._v(" " + _vm._s(this.selectedGroup.name) + " ")]) : _vm._e()]], 2) : _vm._e()], 1), _c('section', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v("Step 2: 請編輯團購設定")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "content-cols": "12",
      "content-cols-lg": "7",
      "label-size": "sm",
      "label": "請輸入商品編號，輸入完畢後，請按確認"
    }
  }, [_vm.useWhichProductSource === 'product_whitelist' ? _c('div', [_c('b-form-select', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "state": _vm.v$.form.product_ids.$error ? false : null,
      "disabled": _vm.isEdit
    },
    on: {
      "change": _vm.handleSelectProduct
    },
    model: {
      value: _vm.selectedProduct,
      callback: function callback($$v) {
        _vm.selectedProduct = $$v;
      },
      expression: "selectedProduct"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇商品 ")]), _vm._l(_vm.productOptions, function (productOption) {
    return _c('b-form-select-option', {
      key: productOption.id,
      attrs: {
        "value": productOption
      }
    }, [_vm._v(" (" + _vm._s(productOption.sale_page_code) + ") " + _vm._s(productOption.title) + " ")]);
  })], 2), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.product_ids.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1) : _vm._e(), _vm.useWhichProductSource === 'all' ? _c('div', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入商品編號",
      "disabled": _vm.isEdit,
      "state": _vm.v$.form.product_ids.$error ? false : null
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearchProducts.apply(null, arguments);
      }
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": _vm.isEdit || !_vm.code
    },
    on: {
      "click": _vm.handleSearchProducts
    }
  }, [_vm._v("確認")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.product_ids.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('ProductViewer', {
    attrs: {
      "loading": _vm.isFetchProduct,
      "product": _vm.selectedProduct
    }
  })], 1) : _vm._e()])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品剩餘總數",
      "label-for": "salableQuantity"
    }
  }, [_vm._v(" " + _vm._s(_vm.salableQuantity) + " ")]), this.isEdit && _vm.groupbuying && (_vm.groupbuying.type === 3 || _vm.groupbuying.type === 4) ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "本群分配庫存",
      "label-for": "max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "readonly": ""
    },
    model: {
      value: _vm.form.max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "max_quantity", $$v);
      },
      expression: "form.max_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.max_quantity.required.$invalid
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.max_quantity.lessThanSalableQuantity.$invalid
    }
  }, [_vm._v(" 需小於商品可賣量 ")])], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "disabled": _vm.isEdit && !_vm.isStatusPrepared,
      "state": _vm.v$.form.once_max_quantity.$error ? false : null,
      "readonly": ""
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於商品總數上限 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": _vm.isEdit && !_vm.isStatusPrepared,
      "state": _vm.v$.form.once_quantity.$error ? false : null,
      "readonly": ""
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於每人最高購買數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": _vm.isEdit && !_vm.isStatusPrepared,
      "state": _vm.v$.form.once_increase_quantity.$error ? false : null,
      "readonly": ""
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "開始時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isEdit && !_vm.isStatusPrepared,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "date", $$v);
      },
      expression: "form.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error
      }],
      "disabled": _vm.isEdit && !_vm.isStatusPrepared
    },
    model: {
      value: _vm.form.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "time", $$v);
      },
      expression: "form.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.time.HH.$error || !_vm.v$.form.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "截止時間",
      "description": "*達截止時間系統將自動結團"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": {
        'is-invalid': _vm.v$.form.start_at.$invalid
      },
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "date", $$v);
      },
      expression: "form.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 截止時間必須大於開團時間 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error || _vm.v$.form.start_at.date.beforeEndAt.$invalid
      }]
    },
    model: {
      value: _vm.form.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "time", $$v);
      },
      expression: "form.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.time.HH.$error || !_vm.v$.form.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工編號",
      "label-for": "tracking_code"
    }
  }, [_vm.groupbuying && _vm.groupbuying.main_id !== null ? _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-100 w-lg-35",
    attrs: {
      "id": "tracking_code",
      "value": "總公司開團",
      "disabled": ""
    }
  }) : _vm._e(), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-100 w-lg-35",
    style: {
      'display': _vm.groupbuying && _vm.groupbuying.main_id !== null ? 'none' : null
    },
    attrs: {
      "id": "tracking_code",
      "formatter": function formatter(value) {
        return value.length > 6 ? value.slice(0, 6) : value;
      },
      "disabled": _vm.isEdit,
      "state": _vm.v$.form.tracking_code.$error ? false : null
    },
    model: {
      value: _vm.form.tracking_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tracking_code", $$v);
      },
      expression: "form.tracking_code"
    }
  }), _vm.v$.form.tracking_code.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e(), _vm.v$.form.tracking_code.lengthSix.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 需為6碼數字 ")]) : _vm._e()], 1), _vm.isEdit && _vm.groupbuying.type !== 1 ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序",
      "label-for": "order"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "id": "order",
      "disabled": _vm.groupbuying.type === 2,
      "state": _vm.v$.form.order.$error ? false : null
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  }), _vm.v$.form.order.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e(), _vm.v$.form.order.lengthTwo.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 需為2碼數字 ")]) : _vm._e()], 1) : _vm._e()], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancelGroupbuy
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "取消編輯" : "取消開團"))]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmitGroupbuy
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "確認編輯" : "確認開團"))])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }